import { apiRequest, HttpMethods } from 'common-src/features/rest';

export const getDocumentPresignedUrl = (id) =>
  apiRequest({
    endpoint: `patientDocuments/${id}/presignedUrl`,
    method: HttpMethods.Get,
  })
    .then((res) => {
      if (res.status !== 200) {
        throw new Error('Error while getting presigned URL for document.');
      }
      return res.json();
    })
    .then((data) => data.presigned_url.replace('"', ''));

/**
 * Opens a document by ID with fallback to download if popup is blocked
 * @param {string|number} id - The document ID
 * @param {string} fileName - The filename to use for download
 * @param {Function} onError - Error callback function
 * @returns {Promise<void>}
 */
export const openDocument = async (id, fileName, onError = () => {}) => {
  try {
    const url = await getDocumentPresignedUrl(id);

    // Attempt to open the document in a new tab first
    const newTab = window.open(url, '_blank');

    // If opening in a new tab fails (blocked by popup blocker or other issues)
    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
      // Fallback to download approach
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    }
  } catch (error) {
    onError(error);
  }
};
